var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 44,
    viewBox: "0 0 184 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22656,
    y: 10.8691,
    width: 7.72934,
    height: 7.72934,
    transform: "rotate(-90.6802 1.22656 10.8691)",
    fill: "#6310CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.22656,
    y: 10.8691,
    width: 7.72934,
    height: 7.72934,
    transform: "rotate(-90.6802 1.22656 10.8691)",
    fill: "#6310CC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4141,
    y: 10.5879,
    width: 7.72934,
    height: 7.72934,
    transform: "rotate(-90.6802 24.4141 10.5879)",
    fill: "#6310CC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4141,
    y: 10.5879,
    width: 7.72934,
    height: 7.72934,
    transform: "rotate(-90.6802 24.4141 10.5879)",
    fill: "#6310CC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.25781,
    y: 25.752,
    width: 15.4587,
    height: 1.93233,
    transform: "rotate(-90.6802 4.25781 25.752)",
    fill: "#6310CC",
    fillOpacity: 0.62
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4453,
    y: 25.9473,
    width: 15.4587,
    height: 1.93233,
    transform: "rotate(-90.6802 27.4453 25.9473)",
    fill: "#8A5BD1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.89062,
    y: 4.9707,
    width: 15.4587,
    height: 1.93233,
    transform: "rotate(-0.680167 8.89062 4.9707)",
    fill: "#8A5BD1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.15625,
    y: 27.0352,
    width: 15.4587,
    height: 1.93233,
    transform: "rotate(-0.680167 9.15625 27.0352)",
    fill: "#8A5BD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8179 13.4311L14.2593 14.7064L10.7067 15.344L0.140161 25.9106L8.33836 34.1088L18.9049 23.5423L19.5426 19.9897L20.8179 13.4311ZM15.9897 18.2592C16.4425 18.712 17.1766 18.712 17.6294 18.2592C18.0821 17.8065 18.0821 17.0724 17.6294 16.6196C17.1766 16.1668 16.4425 16.1668 15.9897 16.6196C15.5369 17.0724 15.5369 17.8065 15.9897 18.2592Z",
    fill: "url(#paint0_linear_1129_17300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4068 31.3823L24.315 23.6535L32.0438 23.5618L32.1355 31.2905L24.4068 31.3823Z",
    fill: "#6310CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7335 19.7627C42.2868 19.7627 41.1858 21.7507 41.1858 24.0751V31.1094H36.8428V23.5551C36.8428 19.1511 39.4425 15.5421 44.7335 15.5421C50.0245 15.5421 52.6853 19.1205 52.6853 23.5551V31.1094H48.3424V24.0751C48.3424 21.7507 47.2108 19.7627 44.7335 19.7627Z",
    fill: "url(#paint1_linear_1129_17300)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1885 31.507C58.7844 31.507 55.6954 27.8981 55.6954 23.494C55.6954 19.1511 59.2432 15.5116 63.8919 15.5116C68.6324 15.5116 72.119 18.937 72.119 23.494V31.1094H67.9902V29.3355C66.9197 30.6812 65.2682 31.507 63.1885 31.507ZM63.8919 27.4393C66.1246 27.4393 67.7761 25.6654 67.7761 23.5246C67.7761 21.3837 66.1246 19.6098 63.8919 19.6098C61.6593 19.6098 60.0384 21.3837 60.0384 23.5246C60.0384 25.6654 61.6593 27.4393 63.8919 27.4393Z",
    fill: "url(#paint2_linear_1129_17300)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1538 15.4198C100.078 15.4198 102.586 18.9675 102.586 23.1881V31.1094H98.2428V23.9221C98.2428 21.5978 97.2335 19.6404 94.848 19.6404C92.493 19.6404 91.4837 21.5672 91.4837 23.861V31.1094H87.1408V23.8916C87.1408 21.5672 86.1315 19.6404 83.7766 19.6404C81.3604 19.6404 80.4123 21.5978 80.4123 23.8916V31.1094H76.0694V23.1881C76.0694 18.9675 78.5467 15.4198 83.4401 15.4198C86.3456 15.4198 88.4559 16.7043 89.3428 18.784C90.2909 16.7043 92.4318 15.4198 95.1538 15.4198Z",
    fill: "url(#paint3_linear_1129_17300)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.36 27.317C116.593 27.317 117.724 25.329 117.724 22.974V15.9703H122.067V23.494C122.067 27.9286 119.437 31.507 114.36 31.507C109.314 31.507 106.683 27.9286 106.683 23.494V15.9703H111.026V23.0046C111.026 25.329 112.127 27.317 114.36 27.317Z",
    fill: "url(#paint4_linear_1129_17300)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.468 19.7627C131.021 19.7627 129.92 21.7507 129.92 24.0751V31.1094H125.577V23.5551C125.577 19.1511 128.177 15.5421 133.468 15.5421C138.759 15.5421 141.42 19.1205 141.42 23.5551V31.1094H137.077V24.0751C137.077 21.7507 135.945 19.7627 133.468 19.7627Z",
    fill: "url(#paint5_linear_1129_17300)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.915 31.507C147.511 31.507 144.422 27.8981 144.422 23.494C144.422 19.1511 147.97 15.5116 152.618 15.5116C157.359 15.5116 160.846 18.937 160.846 23.494V31.1094H156.717V29.3355C155.646 30.6812 153.995 31.507 151.915 31.507ZM152.618 27.4393C154.851 27.4393 156.503 25.6654 156.503 23.5246C156.503 21.3837 154.851 19.6098 152.618 19.6098C150.386 19.6098 148.765 21.3837 148.765 23.5246C148.765 25.6654 150.386 27.4393 152.618 27.4393Z",
    fill: "url(#paint6_linear_1129_17300)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.758 31.1094H165.415V8.99718H169.758V16.8878C170.89 16.0621 172.389 15.5421 174.04 15.5421C178.658 15.5421 181.074 18.4782 181.074 23.2493V31.1094L176.732 31.0788V23.6775C176.732 21.5366 175.569 19.6404 173.367 19.6404C171.196 19.6404 169.758 21.3531 169.758 23.7386V31.1094Z",
    fill: "url(#paint7_linear_1129_17300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1129_17300",
    x1: 20.8179,
    y1: 13.4311,
    x2: 4.23926,
    y2: 30.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#330869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B0FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1129_17300",
    x1: 39.0078,
    y1: 33.6704,
    x2: 61.3416,
    y2: 23.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A5BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#751EF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1129_17300",
    x1: 74.625,
    y1: 7.34767,
    x2: 52.1563,
    y2: 33.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A769CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F10D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1129_17300",
    x1: 99.4219,
    y1: 11.9082,
    x2: 79.2024,
    y2: 37.6312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C20D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873704,
    stopColor: "#8F4BD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1129_17300",
    x1: 119.629,
    y1: 11.646,
    x2: 105.167,
    y2: 32.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E49D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#742AD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1129_17300",
    x1: 137.298,
    y1: 16.1033,
    x2: 121.047,
    y2: 32.5861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE82DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1129_17300",
    x1: 159.304,
    y1: 13.7435,
    x2: 141.594,
    y2: 32.1064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C65DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F1BD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1129_17300",
    x1: 174.969,
    y1: 14.7923,
    x2: 160.412,
    y2: 30.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#700EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A278D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ef5d5420268145733a021b9d2b05caca.svg";
export { ForwardRef as ReactComponent };